import { render } from "./ProtectionTableView.vue?vue&type=template&id=25122961"
import script from "./ProtectionTableView.vue?vue&type=script&lang=js"
export * from "./ProtectionTableView.vue?vue&type=script&lang=js"

import exportComponent from "/home/le01s/projects/amlogger/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__